/* eslint consistent-return: 0 */
/* eslint no-unneeded-ternary: 0 */
import Cookie from 'common/services/util/-RFC.Cookie';
import log from 'common/services/logging/loggers';

const jwtDecode = require('jwt-decode');

const Util = {
    /**
     * @ngdoc function
     * @name services.Util#deepFind
     * @methodOf services.Util
     * @function
     *
     * @description
     * Get nested object value from path without throwing error.
     *
     * @param {Object} obj obj.
     * @param {string} path path.
     */
    deepFind(obj, path) {

        let current;
        let i;
        if (!obj) {

            return;

        }

        const paths = path.split('.');
        current = obj;

        for (i = 0; i < paths.length; i += 1) {

            if (current[paths[i]] === undefined || current[paths[i]] === null) {

                return;

            }

            current = current[paths[i]];

        }

        return current;

    },

    /**
     * Checks if a user is anonymous.
     * @return boolean True if the JWT attribute anon is true
     */
    isAnonymous() {

        const token = Cookie.get(CWCONFIG.cookie.token);

        if (token) {

            try {

                const decodedToken = jwtDecode(token);
                return decodedToken.anon === true;

            } catch (err) {

                log.error(err);
                return false;

            }

        }
        return false;

    },
    // this is to check if the appId is one of the app that we no longer promote upsell in dashboard
    isNonrenewableApp(appId) {

        const { nonrenewableApps } = CWCONFIG;
        return !!(nonrenewableApps.find(id => id === appId));

    },

};

export default Util;



// WEBPACK FOOTER //
// ./scripts/common/services/util/-RFC.util.js